import zhCn from './zh-cn'
// import zhTw from './zh-tw'
import en from './en'
// import id from './id'

/**
 * 合并语言包
 * @type {string}
 * zh-cn 中文简体
 * zh-tw 中文繁体
 * en 英文
 * id 印尼语
 */
export default {
    'en': en,
    'zh-cn': zhCn,
    // 'zh-tw': zhTw,
    // 'id': id
}
